import IDiscipline from '@interfaces/IDiscipline'
import axios from 'axios'

export const disciplines = (params: any = {}): Promise<IDiscipline[]> => axios.get('/accesses/disciplines', {
  params,
})
